<template>
  <Transition name="slide-up">
    <!-- 备案号固定展示在页面底部，不再受 Cookie 同意状态控制。 -->
    <div class="cookie-banner cookie-banner-pc">
      <div class="cookie-content">
        <!-- 使用新窗口打开工信部官网，并阻断新窗口反向访问当前页面。 -->
        <a
          href="https://beian.miit.gov.cn/"
          target="_blank"
          rel="noopener noreferrer"
          class="filing-link"
        >
          渝ICP备2024044486号-7
        </a>
      </div>
    </div>
  </Transition>
</template>

<style lang="less" scoped>
.cookie-banner-pc {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 9999;
  background: linear-gradient(180deg, #1a2734 0%, rgba(75, 80, 230, 0.95) 100%);
  backdrop-filter: blur(10px);
  box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.3);
  padding: 24px 40px;
  box-sizing: border-box;

  .cookie-content {
    max-width: 1400px;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .filing-link {
    color: #00ffe0;
    font-size: 14px;
    line-height: 1.5;
    text-align: center;
    text-decoration: underline;
    cursor: pointer;
    transition: opacity 0.2s ease;

    &:hover {
      opacity: 0.8;
    }
  }
}

// 动画效果
.slide-up-enter-active,
.slide-up-leave-active {
  transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1),
    opacity 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.slide-up-enter-from {
  transform: translateY(100%);
  opacity: 0;
}

.slide-up-leave-to {
  transform: translateY(100%);
  opacity: 0;
}
</style>
